// extracted by mini-css-extract-plugin
module.exports = {"Home":"Avatar_Home__QdHFR","Content":"Avatar_Content__37BWO","AvatarList":"Avatar_AvatarList__1oPDo","Avatar":"Avatar_Avatar__1MPHQ"};